import "owl.carousel";
import { cardFilter } from "./components/card-filter";
import { playVideo } from "./components/video";
import { navigation } from "./components/navigation";
import { teamFiltering } from "./components/team-filtering";

(function ($) {
  $(document).ready(function () {
    cardFilter();
    navigation();
    teamFiltering();

    $(".video-wrapper .play-button").on("click", function () {
      playVideo($(this));
    });

    /** Team mobile carousel */
    const $teamCarousel = $(".team-carousel");
    $teamCarousel.each(function () {
      $(this).owlCarousel({
        items: 1,
        loop: true,
        nav: false,
        dots: true,
        autoHeight: true,
      });
    });

    /** Quote Carousel */
    const $quoteCarousel = $(".quote-carousel");
    $quoteCarousel.each(function () {
      const randId = $(this).parents(".quote").attr("data-id");

      $(this).owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: true,
        autoHeight: true,
        navContainer: `.quote[data-id="${randId}"] .custom-nav-container`,
      });
    });

    /** Case Studies Carousel */
    const $caseStudiesCarousel = $(".case-studies-carousel");
    $caseStudiesCarousel.each(function () {
      const randId = $(this).parents(".case-study-carousel").attr("data-id");

      $(this).owlCarousel({
        loop: true,
        nav: true,
        dots: true,
        autoHeight: true,
        navContainer: `.case-study-carousel[data-id="${randId}"] .custom-nav-container`,
        responsive: {
          0: {
            items: 1.2,
            margin: 30,
          },
          768: {
            items: 2.5,
            margin: 60,
          },
          1400: {
            items: 2.5,
            margin: 60,
          },
          1600: {
            items: 3.5,
            margin: 60,
          },
        },
      });
    });

    /** Circular Cards Carousel */
    const $circularCardsCarousel = $(".circular-cards-carousel");

    // Function to initialize the carousel
    function initializeCarousel() {
      $circularCardsCarousel.each(function () {
        $(this).owlCarousel({
          items: 1,
          loop: true,
          margin: 60,
          nav: false,
          dots: true,
          autoHeight: true,
        });
      });
    }

    // Function to destroy the carousel and reset to default
    function destroyCarousel() {
      $circularCardsCarousel
        .trigger("destroy.owl.carousel")
        .removeClass("owl-loaded");
      $circularCardsCarousel.find(".owl-stage-outer").children().unwrap();
    }

    // Initial check to see if we should initialize the carousel
    if ($(window).width() <= 768) {
      initializeCarousel();
    }

    // Listen for window resize events
    $(window).resize(function () {
      const windowWidth = $(window).width();
      if (
        windowWidth <= 768 &&
        !$circularCardsCarousel.hasClass("owl-loaded")
      ) {
        initializeCarousel();
      } else if (
        windowWidth > 768 &&
        $circularCardsCarousel.hasClass("owl-loaded")
      ) {
        destroyCarousel();
      }
    });

    // $(window)
    //   .on("resize", () => {
    //     $caseStudiesCarousel.each(function () {
    //       const $normalContainer = $(this)
    //         .parents(".case-study-carousel")
    //         .find(".normal-container");
    //       const $customContainer = $(this)
    //         .parents(".case-study-carousel")
    //         .find(".custom-container");

    //       // get the left position of the normal container
    //       const left = $normalContainer.offset().left;

    //       $customContainer.css({
    //         left: left / 2,
    //         width: `calc(100% - ${left}px)`,
    //       });
    //     });
    //   })
    //   .resize();

    /** Parner Logos */
    $(".partner-logos .marquee").owlCarousel({
      items: 7,
      loop: true,
      margin: 60,
      autoWidth: true,
      autoplay: true,
      slideTransition: "linear",
      autoplaySpeed: 6000,
      autoplayTimeout: 3000,
    });

    // Function to handle scrolling to an element
    const scrollToElement = (selector) => {
      const element = $(selector);
      if (element.length) {
        $("html, body").animate(
          {
            scrollTop: element.offset().top,
          },
          "smooth"
        );
      }
    };

    // Attach click event to all anchor tags
    $("a").click(function (e) {
      const target = $(this).attr("href");
      // Check if the target contains a hash
      if (target.includes("#")) {
        const hashIndex = target.indexOf("#");
        const hash = target.substring(hashIndex);
        // Further check if the hash is for an anchor on the current page
        if (hash.length > 1 && $(hash).length) {
          e.preventDefault();
          scrollToElement(hash);
        }
        // If the hash is not for the current page, the default action continues
      }
      // For links without hashes, the default action continues
    });

    // Ensure the entire page is loaded before scrolling to the hash
    $(window).on("load", function () {
      const hash = window.location.hash;
      if (hash) {
        scrollToElement(hash);
      }
    });
  });
})(jQuery);
